// extracted by mini-css-extract-plugin
export var button = "SubmitButton-module__button___YAjxm";
export var errorMessage = "SubmitButton-module__errorMessage___WetXR";
export var row = "SubmitButton-module__row___wYMH5";
export var termsAndConditions = "SubmitButton-module__termsAndConditions___r0YeU";